import React from "react";
import SecondaryHeading from "../../components/common/Typography/SecondaryHeading";
import Paragraph from "../../components/common/Typography/Paragraph";

const Biography = ({ userData, className = "" }) => {
  // Fallback biography text
  const fallbackBiography = "The services that an architect typically provides include concept design development, preparation of construction documents, and construction administration. The services that an architect typically provides include concept design development, preparation of construction documents, and construction administration.";

  // Get biography from userData or use fallback
  const biography = userData?.businessBio || userData?.biography || fallbackBiography;

  return (
    <div className={`mb-8 ${className}`}>
      <SecondaryHeading variant={"MainParagraphHeading"} className={"text-offblack mb-4"}>
        Biography
      </SecondaryHeading>
      <Paragraph variant={"MainParagraph"} className={"text-offblack"}>
        {biography}
      </Paragraph>
    </div>
  );
};

export default Biography;
